import * as Sentry from '@sentry/react';
import { env, isDev } from '@utils/env';

export function initSentry(): void {
  if (!env.VITE_SENTRY_DSN || isDev) return;
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_APP_ENV,
    tracesSampleRate: env.VITE_APP_ENV === 'prod' ? 0.1 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
  });
}

export function captureError(error: unknown): void {
  Sentry.captureException(error);
}
